<template>
  <div class="navbar-right clearfix" :key="'nav-right'">
    <router-link to="/signin" class="hover-link light d-none d-lg-inline-block">
      <i class="uil uil-entry"></i>Sign in
    </router-link>
    <component :is="toggle"></component>
  </div>
</template>

<script>
import MainNavToggle from '@/components/header/MainNavToggle.vue'

export default {
  name: 'nav-right',
  components: {
    MainNavToggle
  },
  props: {
    toggle: String
  }
}
</script>
